import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { DesyAngularModule } from 'desy-angular';
import { SpanishDatePipe } from '../../../pipe/date.pipe';
import { Buttons, Info } from '@/app/interfaces/projects';
import { ButtonsComponent } from '../../buttons/buttons.component';
import { RiskLevelClassPipe } from '../../../pipe/riskLevelClass.pipe';
import { getProjectStateInfo } from '../../mappers/project-state.mapper';
import { mapRiskLevelLabel } from '@/app/shared/mappers/risk-level-label.mapper';

@Component({
  selector: 'app-project-card',
  standalone: true,
  imports: [DesyAngularModule, CommonModule, SpanishDatePipe, ButtonsComponent, RiskLevelClassPipe],
  templateUrl: './project-card.component.html',
  styleUrls: ['./project-card.component.scss'],
})
export class ProjectCardComponent {
  @Input() projectName = '';
  @Input() buttons: Buttons[];
  @Input() creationUser = '';
  @Input() creationDate: Date | null = null;
  @Input() infoCard: Info[] = [];
  @Input() description: string = null;
  @Input() dataPerRow = 3;

  private _state = '';
  @Input() set state(value: string) {
    this._state = value;
    this.color = getProjectStateInfo(value).className;
  }
  get state(): string {
    return this._state;
  }

  color = '';

  riskLevelLabel(value: string): string {
    return mapRiskLevelLabel(value);
  }

  get dataPerRowMdClass(): string {
    switch (this.dataPerRow) {
      case 1:
        return 'md:grid-cols-1';
      case 2:
        return 'md:grid-cols-2';
      case 3:
        return 'md:grid-cols-3';
      case 4:
        return 'md:grid-cols-4';
      case 5:
        return 'md:grid-cols-5';
      case 6:
        return 'md:grid-cols-6';
      default:
        return 'md:grid-cols-3';
    }
  }

  get stateText(): string | null {
    return this.state ? getProjectStateInfo(this.state).label : null;
  }
}
